import React from 'react';

import anonAvatar from 'assets/images/anon-avatar.jpg';

import { UserAvatar } from 'core/components/user';
import * as Styled from './StyledMatchEvaluator';

export const MatchEvaluator = ({ match }) => {
    let { evaluator } = match;
    if (match.anonymous) {
        evaluator = { ...evaluator, photoUrl: anonAvatar };
    }

    return (
        <Styled.MatchEvaluator className={`${match.anonymous ? 'anonymous' : ''}`}>
            <UserAvatar user={evaluator} />
            <Styled.Infos>
                <span className="name">{evaluator.fullName}</span>

                {match.anonymous ? (
                    <i className="anonymous">Este avaliador optou em manter-se anônimo.</i>
                ) : (
                    <>
                        <span className="company">{match.evaluator.company}</span>
                        <span className="position">{evaluator.position}</span>
                    </>
                )}
            </Styled.Infos>
        </Styled.MatchEvaluator>
    );
};
